<template>
  <div>
    <vs-button icon-pack="feather" icon="icon-chevrons-down" type="border" @click="popupActive=true">{{title}}</vs-button>
    <vs-popup
        title="Import Basic Dream"
        :active.sync="popupActive"
        fullscreen
    >
      <div class="vx-row">
        <template v-for="dream in dreamsToImport">
            <div class="vx-col xs:w-full sm:w-1/2 md:w-1/2 lg:w-1/4" :key="dream.id">
            <vx-card class="dream" >

              <vs-tabs>
                <vs-tab label="Detail">
                  <div class="mt-3">
                    <h4 v-if="dream.title">
                      {{ dream.title }}
                    </h4>
                    <p v-if="dream.subtitle" class="text-grey mt-2">
                      {{ dream.subtitle }}
                    </p>
                  </div>
                </vs-tab>
                <vs-tab label="Goals">
                    <div class="mt-3">
                       <ul v-for="goal in dream.goals" :key="goal.title">
                          <li>
                            {{goal.title}}
                          </li>
                       </ul>
                    </div>
                </vs-tab>
              </vs-tabs>

              <div slot="no-body">
                <img :src="dream.img" class="responsive card-img-top" />
              </div>


              <div class="flex justify-between flex-wrap">
                <vs-button class="mt-4" color="primary" @click="importDream(dream)">
                  Import Dream
                </vs-button>
              </div>

            </vx-card>
          </div>
        </template>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import trackAnalytics from '@/helpers/trackAnalytics'

export default {
  props: {
    detailMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: 'Import Dream'
    }
  },
  data () {
    return {
      popupActive: false,
      dreamsToImport: [
        {
          title: 'Improve diet🥕',
          img: 'https://i.ibb.co/zGbzfQr/healthy-food-1024x1024.jpg',
          subtitle: 'Eating well is fundamental to good health and well-being. Maintaining a healthy diet reduces the likelihood of depression and gives you more energy to enjoy life and achieving your dreams.',
          goals: [
            {
              title: 'Study essential Vitamines',
              subgoals: [
                { title: 'Vitamine A benefits and sources' },
                { title: 'Vitamine B benefits and sources' },
                { title: 'Vitamine C benefits and sources' },
                { title: 'Vitamine D benefits and sources' },
              ]
            },
            {
              title: 'Study essential Minerals',
              subgoals: [
                { title: 'Zinc benefits and sources' },
                { title: 'Magnesium benefits and sources' },
                { title: 'Calcium benefits and sources' },
              ]
            },
            {
              title: 'Know fatty acids',
              subgoals: [
                { title: 'Omega 3' },
                { title: 'Omega 6' },
                { title: 'Omega 9' },
                { title: 'Propper ratio between omegas' },
              ]
            },
            {
              title: 'No junk food for a whole month'
            },
            {
              title: 'Proper Hydratation - 1.5l daily'
            },
            {
              title: 'Limit added suggar'
            },
            {
              title: 'Limit processed food'
            },
            {
              title: 'Avoid alcolhol and cigarettes'
            },
          ]
        },
        // {
        //   id: 2,
        //   img: 'https://i.ibb.co/KryM5Hm/421-4217129-yoga-fitness-sporty-silhouette-man-working-out-silhueta.png',
        //   title: 'Be fit 💪',
        //   subtitle: 'subtitle',
        //   goals: [
        //     {
        //       title: 'Improve dietTilte1'
        //     },
        //     {
        //       title: 'Improve dietTilte2'
        //     },
        //     {
        //       title: 'Improve dietTilte3'
        //     },
        //     {
        //       title: 'Improve dietTilte4'
        //     },
        //   ]
        // },
        {
          img: 'https://i.ibb.co/jvL20HG/dabc2c499d4e6b065edc9cfaeea5580c.jpg',
          title: 'Improve sleep 💤',
          subtitle: 'Sleep is maybe even more important than you think. Sleep is the most effective recovery mechanism we have. Propper rest refreshes your mind and gives energy to your body.',
          goals: [
            {
              title: 'Learn about Circadian rhythm'
            },
            {
              title: 'Listen Joe Rogan Experience #1109 with Matthew Walker'
            },
            {
              title: 'Learn about the effect of Blue light'
            },
            {
              title: 'Learn about a Melatonin hormone'
            },
            {
              title: 'Daily Better sleep routine',
              subgoals: [
                { title: 'Do some physical activity' },
                { title: 'Eat your last meal at least 3h before bed' },
                { title: 'Block the blue light - Night shift, etc..' },
                { title: 'Do not look into screens 1h before bed' },
                { title: 'Go to the bed roughly at the same time' },
                { title: 'Leave electronics outside the bedroom' },
                { title: 'Sleep for 7-9h' },
              ]
            },
            {
              title: 'Try to wear a sleep mask'
            },
            {
              title: 'Try ear plugs'
            },
          ]
        },
        {
          img: 'https://i.ibb.co/KzpS7vR/Comfort-zone-vs-where-the-magic-happens.jpg',
          title: 'Escape comfort zone 👀',
          subtitle: 'Leaving your comfort zone is necessary if you want to live a fulfilling life. When you leave your comfort zone, you allow yourself to grow and improve.',
          goals: [
            { title: 'Brush your teeth with your left hand' },
            { title: 'Go outside and scream on top of your lungs ' },
            { title: 'Walk in the nature without shoes' },
            { title: 'Ask a stranger about how he/she feels today' },
            { title: 'Use no cosmetics today' },
            { title: 'Go out with a friend you haven\'t seen for years' },
            { title: 'Cook something new today' },
            { title: 'Give away something you haven\'t used for a while' },
            { title: 'Tell something nice to somebody you hate' },
            { title: 'Give $5 or more to a random person' },
            { title: 'Don\'t talk with anybody whole day' },
          ]
        },
      ],
      imageFile: null,
    }
  },
  methods: {
    async importDream ({ title, img, subtitle, goals }) {
      this.storeDream({ title, img, subtitle }, goals)
      this.popupActive = false
      trackAnalytics(this, 'app_action', 'import_dream', null, this.$store.getters.daysFromRegistration)
    },

    async storeDream (dream, goals) {
      const res = await this.$store.dispatch('ADD_DREAM', { dream })
      this.$vs.notify({
        title:'Success!',
        text:'You have imported a dream',
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
      })
      const dreamId = res.id
      goals.forEach(goal => this.storeGoal(dreamId, goal))
    },

    async storeGoal (dreamId, { subgoals, title }) {
      const res = await this.$store.dispatch('ADD_GOAL', { goal: { dreamId, title } })
      const goalId = res.id
      if (subgoals) {
        subgoals.forEach(subgoal => this.$store.dispatch('ADD_SUBGOAL', { subgoal: { goalId, ...subgoal } }))
      }
    },
  }
}
</script>
<style>
.img-upload, .con-upload, .con-img-upload, .con-input-upload {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
}

.con-input-upload {
  height: 120px;
}

.view-upload {
  display: none !important;
}
</style>
